import {
  ATBeaconButton,
  ATBeaconModal,
} from 'components/common/beacon/beaconRegistration';
import React, { useEffect } from 'react';
import { dispatchOverlayLoad } from 'utils/analyticsUtil';
import { CTAVariants } from '@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant';

const MUTUAL_FUND_TRANSFERS_URL =
  'https://www.troweprice.com/personal-investing/account-finder/transfers.html';
const DASHBOARD_URL = 'https://www.troweprice.com/usis/client-portal/dashboard';

interface MutualFundOnlyModalProps {
  open: boolean;
}

const MutualFundOnlyModal: React.FC<MutualFundOnlyModalProps> = ({ open }) => {
  useEffect(() => {
    if (open) {
      dispatchOverlayLoad("You don't have a brokerage account with us");
    }
  }, [open]);

  const handleMutualFundTransfers = () => {
    window.location.href = MUTUAL_FUND_TRANSFERS_URL;
  };

  const handleGoToDashboard = () => {
    window.location.href = DASHBOARD_URL;
  };

  return (
    <div className="beacon-on-light">
      <ATBeaconModal
        open={open}
        id="mutual-fund-only-modal"
        data-testid="mutual-fund-only-modal"
      >
        <h2 className="b-typography-serif--headline--200 b-font-weight-bold">
          You don&apos;t have a brokerage account with us
        </h2>
        <div className="b-typography-sans-serif--body--200 b-font-weight-light">
          This page is for brokerage asset transfers only. If you&apos;d like to transfer
          mutual fund assets, please visit our mutual fund transfers page.
        </div>
        <div slot="action-zone" className="action-zone-align-right">
          <ATBeaconButton
            slot="close-button-text"
            variant={CTAVariants.Tertiary}
            onBeaconEventClick={handleGoToDashboard}
          >
            Go to Dashboard
          </ATBeaconButton>
          <ATBeaconButton
            slot="close-button-text"
            variant={CTAVariants.Primary}
            onBeaconEventClick={handleMutualFundTransfers}
          >
            Mutual Fund Transfers
          </ATBeaconButton>
        </div>
      </ATBeaconModal>
    </div>
  );
};

export default MutualFundOnlyModal;
